import 'css-chunk:src/app/containers/Home/OrganizationsView/ClientGroup/ClientGroupDetailView.scss';export default {
  "ClientGroupDetailView": "_ClientGroupDetailView_eloeu_1"
};